import styled, { css } from 'styled-components';
import { testableStyledComponentConfig } from '@24i/nxg-sdk-gluons';
const PERCENT = 100;
const containerHeight = 4;
const containerHeightActive = 6;
const transitionDuration = '200ms';
const touchableArePadding = 10;
const dotSize = 14;
const dotSizeActive = 20;
const progressTimeContainerSize = 140;
export const Container = styled.div.withConfig(testableStyledComponentConfig) `
    position: relative;
    display: flex;
    flex: 1;
    transition: height ${transitionDuration}, opacity ${transitionDuration},
        visibility ${transitionDuration};
    height: ${({ isActive }) => (isActive ? containerHeightActive : containerHeight)}px;
    opacity: ${({ isVolumeOpened, variant }) => (isVolumeOpened && variant !== 'podcast' ? 0 : 1)};
    visibility: ${({ isVolumeOpened, variant }) => isVolumeOpened && variant !== 'podcast' ? 'hidden' : 'visible'};
`;
export const SeekingContainer = styled.div `
    position: absolute;
    width: 100%;
    height: 100%;
    padding: ${touchableArePadding}px 0;
    margin-top: -${(touchableArePadding * 2 + containerHeight) / 2 - containerHeight / 2}px;
`;
export const AbsoluteContainer = styled.div.attrs(({ progress, dvrWindowFromLeft = 0, dvrWindowFromRight = PERCENT }) => ({
    style: {
        width: `${Math.min(dvrWindowFromRight - dvrWindowFromLeft, progress - dvrWindowFromLeft)}%`,
        left: `${dvrWindowFromLeft}%`,
    },
})) `
    position: absolute;
    height: 100%;
    border-radius: ${containerHeight}px;
    background: ${(props) => props.color};
`;
export const DVRWindow = styled.div.attrs(({ dvrWindowFromLeft, dvrWindowFromRight }) => ({
    style: {
        left: `${dvrWindowFromLeft}%`,
        width: `${dvrWindowFromRight - dvrWindowFromLeft}%`,
    },
})) `
    position: absolute;
    height: 100%;
    border-radius: ${containerHeight}px;
    background: rgba(255, 255, 255, 0.4);
`;
export const ProgressDot = styled.div.attrs(({ progress, dvrWindowFromLeft = 0, dvrWindowFromRight = PERCENT }) => ({
    style: {
        left: `${Math.max(dvrWindowFromLeft, Math.min(dvrWindowFromRight, progress))}%`,
    },
})) `
    position: absolute;
    height: ${dotSize}px;
    width: ${dotSize}px;
    top: ${({ isActive }) => isActive
    ? containerHeightActive / 2 - dotSizeActive / 2
    : containerHeight / 2 - dotSize / 2}px;
    margin-left: -${dotSize / 2}px;
    border-radius: 50%;
    background: ${(props) => { var _a, _b; return (_b = (_a = props.styles) === null || _a === void 0 ? void 0 : _a.progressDot) === null || _b === void 0 ? void 0 : _b.backgroundColor; }};
    transition: height ${transitionDuration}, width ${transitionDuration}, top ${transitionDuration},
        margin-left ${transitionDuration};

    ${(props) => props.isActive &&
    css `
            height: ${dotSizeActive}px;
            width: ${dotSizeActive}px;
            margin-left: -${dotSizeActive / 2}px;
        `}
`;
export const ProgressTimeContainer = styled.div.attrs(({ progress }) => ({
    style: {
        left: `${progress}%`,
    },
})) `
    position: absolute;
    height: 23px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: ${progressTimeContainerSize}px;
    top: -35px;
    margin-left: -${progressTimeContainerSize / 2}px;
    background: ${(props) => { var _a, _b; return (_b = (_a = props.styles) === null || _a === void 0 ? void 0 : _a.progressBar) === null || _b === void 0 ? void 0 : _b.backgroundColor; }};
`;
export const getDefaultTimelineStyles = (theme) => {
    var _a, _b;
    const defaultProgressColor = ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.progressBarAccent) || 'white';
    return {
        container: null,
        backgroundContainer: null,
        buffered: null,
        dvrWindow: null,
        progress: null,
        midrolls: null,
        progressDot: {
            backgroundColor: defaultProgressColor,
        },
        progressBar: {
            backgroundColor: ((_b = theme === null || theme === void 0 ? void 0 : theme.color) === null || _b === void 0 ? void 0 : _b.progressBarPreAccent) || defaultProgressColor,
        },
        progressTime: {},
    };
};
//# sourceMappingURL=index.js.map